<ul class="pagination" *ngIf="pages.length">
	<li *ngIf="showFirst" (click)="onPage(1)"><a href="javascript:void(0);">First</a></li>
	<li class.disabled="page == 1" (click)="onPrev()"><a href="javascript:void(0);">&laquo;</a></li>
	<li *ngFor="let _page of pages" [class.active]="page == _page">
		<a href="javascript:void(0);" (click)="onPage(_page)">{{ _page }}</a>
	</li>
	<li [class.disabled]="page == pageLast" (click)="onNext()"><a href="javascript:void(0);">&raquo;</a></li>
	<li *ngIf="showLast" (click)="onPage(pageLast)"><a href="javascript:void(0);">Last</a></li>
</ul>